export const getNamedLocations = (state) => {
  return state.namedLocations
}

export const getAggregatedLocations = (state) => {
  return state.aggregatedLocations
}

export const getLocationHistory = (state) => {
  return state.locationHistory
}

export const getAlertSettings = (state) => {
  return state.alertSettings
}

export const getNamedLocationById = (state) => (id) => {
  return state.namedLocations.find(location => location.id === id)
}

export const getAggregatedLocationById = (state) => (id) => {
  return state.aggregatedLocations.find(location => location.id === id)
}

export const getAlertSettingsById = (state) => (id) => {
  return state.alertSettings.filter(setting => setting.named_location_id === id)
}